import { render, staticRenderFns } from "./ManageQuestionForm.vue?vue&type=template&id=80e8a916&scoped=true"
import script from "./ManageQuestionForm.vue?vue&type=script&lang=js"
export * from "./ManageQuestionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e8a916",
  null
  
)

export default component.exports